import { createTheme } from '@mui/material'

import theme from 'theme'

export const muiTheme = createTheme({
  typography: {
    // use our font (Sohne)
    fontFamily: theme.fonts.base,
    // turn off any built-in text transformations (e.g., capitalizing button text)
    allVariants: {
      textTransform: 'none'
    }
  },
  // TODO re-enable custom theme coloring later
  // // docs https://mui.com/material-ui/customization/palette/
  // palette: {
  //   primary: {
  //     main: theme.colors.blue[0]
  //     // these should be calculated based on main, but we can override them individually if we want
  //     // light: '#5c5c5c',
  //     // dark: '#0c0c0c',
  //     // contrastText: '#ffffff'
  //   },
  //   secondary: {
  //     main: theme.colors.steel[2]
  //     // light: '#ffffff',
  //     // dark: '#b4b4b4',
  //     // contrastText: '#000000'
  //   },
  //   error: {
  //     main: theme.colors.red[1]
  //     // light: '#cf5263',
  //     // dark: '#650014',
  //     // contrastText: '#ffffff'
  //   },
  //   warning: {
  //     main: theme.colors.orange[0]
  //     // light: '#ffa440',
  //     // dark: '#bb4400',
  //     // contrastText: '#000000'
  //   },
  //   info: {
  //     main: theme.colors.blue[0]
  //     // light: '#5c5c5c',
  //     // dark: '#0c0c0c',
  //     // contrastText: '#ffffff'
  //   },
  //   success: {
  //     main: theme.colors.green[0]
  //     // light: '#67f7b6',
  //     // dark: '#009159',
  //     // contrastText: '#000000'
  //   }
  //   // Used by `getContrastText()` to maximize the contrast between
  //   // the background and the text.
  //   //contrastThreshold: 3,
  //   // Used by the functions below to shift a color's luminance by approximately
  //   // two indexes within its tonal palette.
  //   // E.g., shift from Red 500 to Red 300 or Red 700.
  //   //tonalOffset: 0.2,
  // },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
      @font-face {
        font-family: 'Sohne VF';
        src: local(😜), url('/public/fonts/SohneVF-web.woff2') format('woff2');
        font-style: normal;
        font-variation-ligatures: normal;
        font-weight: 400 600;
      }

      @font-face {
        font-family: 'Sohne Mono';
        src: local(😜), url('/public/fonts/SohneMono-light.woff2') format('woff2');
        font-weight: 300;
        font-style: normal;
      }
      
      @media print {
        body {
          /* These overrides preserve the background coloring of various MUI components when printing the window */
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }`
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
      // example of overriding styles in a component
      // styleOverrides: {
      //   root: {
      //     textTransform: 'none'
      //   }
      // }
    },
    // TODO staying with default theme for now, but leave this here so we can implement it later
    MuiButton: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
          textTransform: 'uppercase'
        }
      }
    },
    /**
     * This theme override is to specifically emulate a disabled link style to render like a disabled button
     */
    MuiLink: {
      styleOverrides: {
        root: {
          '&[data-disabled=true]': {
            color: 'rgba(0, 0, 0, 0.26)',
            textDecoration: 'none',
            pointerEvents: 'none'
          }
        }
      }
    }
  }
})
